var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headerAdComponents"},[_c('div',{staticClass:"leftAd fl padding10"},[_c('al-image',{attrs:{"src":_vm.AdInfo.leftAd.url,"fit":"cover"}})],1),_c('div',{staticClass:"rightAd fr padding10"},[_c('al-image',{attrs:{"src":_vm.AdInfo.rightAd.url,"fit":"cover"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }